import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Translate } from "../../../Enums/Tranlate";
import Select from "react-select";
import VendorsService from "../../../../services/VendorsService";
import DiscountService from "../../../../services/DiscountService";

const AddDiscountModal = ({ addModal, setAddModal, item, setShouldUpdate }) => {
	const lang = useSelector((state) => state.auth.lang);
	const location = useLocation();
	const [formData, setFormData] = useState({
		name: "",
		code: "",
		type: "",
		price: "",
		vendor: "",
	});
	const typesOptions = [
		{ label: Translate[lang].fixed, value: "fixed" },
		{ label: Translate[lang].percentage, value: "percentage" },
	];
	const [vendorsOptions, setVendorsOptions] = useState([]);
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const discountService = new DiscountService();
	const vendorsService = new VendorsService();

	useEffect(() => {
		vendorsService.getList().then((res) => {
			if (res?.status) {
				let response = res?.data?.data?.data?.map((info) => {
					return {
						...info,
						label: info[`name_${lang}`],
						value: info?.id,
					};
				});
				setVendorsOptions(response);
			}
		});
	}, []);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name: item?.name,
				code: item?.code,
				price: item?.price,
				type: typesOptions.find((res) => res?.value === item?.type),
				vendor: {
					label: item?.vender[`name_${lang}`],
					value: item?.vender?.id,
				},
			});
		}
	}, [location]);

	const submit = (e) => {
		e.preventDefault();
		if (!formData?.vendor || !formData?.type) {
			if (!formData?.type) toast.error("Select Type");
			if (!formData?.vendor) toast.error("Select Vendor");
			return;
		}

		let data = {
			name: formData?.name,
			code: formData?.code,
			price: formData?.price,
			type: formData?.type?.value,
			vender_id: formData?.vendor?.value,
		};

		setLoading(true);
		if (isAdd) {
			discountService.create(data)?.then((res) => {
				if (res?.status === 201) {
					toast.success(res?.data?.message);
					setAddModal();
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			});
		} else {
			discountService.update(formData?.id, data)?.then((res) => {
				if (res?.status === 200) {
					toast.success(res?.data?.message);
					setAddModal();
					setShouldUpdate((prev) => !prev);
				}
				setLoading(false);
			});
		}
	};

	const inputHandlerChange = (e) => {
		setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	return (
		<Modal
			className={lang === "en" ? "en fade addAdmin" : "ar fade addAdmin"}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<Modal.Body>
				<AvForm className="form-horizontal" onValidSubmit={submit}>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0 text-black fw-bold"
									style={{
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.discount}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						{/* Name */}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.name}</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Code*/}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.code}</label>
							<AvField
								type="text"
								placeholder={Translate[lang]?.code}
								bsSize="lg"
								name="code"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.code}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Price */}
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.price}</label>
							<AvField
								type="number"
								placeholder={Translate[lang]?.price}
								bsSize="lg"
								name="price"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.price}
								onChange={(e) => inputHandlerChange(e)}
							/>
						</Col>
						{/* Type */}
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.type}</label>
							<Select
								placeholder={Translate[lang]?.select}
								bsSize="lg"
								options={typesOptions}
								name="type"
								value={formData.type}
								onChange={(e) => setFormData((prev) => ({ ...prev, type: e }))}
							/>
						</Col>
						{/* Vendor */}
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.vendor}</label>
							<Select
								placeholder={Translate[lang]?.select}
								bsSize="lg"
								options={vendorsOptions}
								name="vendor"
								value={formData.vendor}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, vendor: e }))
								}
							/>
						</Col>
					</Row>
					<Row>
						<Col md={12} className="mt-4">
							<Button
								variant="primary"
								type="submit"
								className="w-100"
								disabled={loading}>
								{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
								{Translate[lang]?.discount}
							</Button>
						</Col>
					</Row>
				</AvForm>
			</Modal.Body>
		</Modal>
	);
};

export default AddDiscountModal;
